import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({}).set('Response', new Immutable.Map({})).set('Search', new Immutable.List([]))
	.set('Contract', new Immutable.List([]))
	.set('TypeContract', new Immutable.List([]))
	.set('ContractItem', new Immutable.Map({}))

/* Types */

export const ACTION_NEW_CONTRACT = 'ACTION_NEW_CONTRACT'
export const ACTION_TYPE_CONTRACT = 'ACTION_TYPE_CONTRACT'
export const ACTION_SEARCH_CONTRACT = 'ACTION_SEARCH_CONTRACT'
export const ACTION_GET_ITEM_CONTRACT = 'ACTION_GET_ITEM_CONTRACT'



/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case ACTION_NEW_CONTRACT:
			return state.set('Contract', new Immutable.List(action.Obj))
		case ACTION_TYPE_CONTRACT:
			return state.set('TypeContract', new Immutable.List(action.Obj))
		case ACTION_SEARCH_CONTRACT:
			return state.set('Contract', new Immutable.List(action.Obj))
		case ACTION_GET_ITEM_CONTRACT:
			return state.set('ContractItem', new Immutable.Map(action.Obj))

		default:
			return state;
	}
};

/* Action Creators */

export const newAndUpdateContract = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		let formAux = Object.assign({}, form)
		delete formAux.editorState
		delete formAux.textEditor
		delete formAux.firmas
		delete formAux.paginaActual
		delete formAux.textoActual
		delete formAux.textoComplementario
		delete formAux.idTipoContrato
		delete formAux.nameContrato

		formAux.createdBy = formAux.lastModifiedBy = sessionStorage.uid
		//formAux.createdDate = formAux.lastModifiedDate = new Date().toISOString()

		formAux.firma1.map( (item,i) => {
			item.id = i
			item.createdBy=item.lastModifiedBy = sessionStorage.uid
			//item.createdDate = new Date().toISOString().replace('abc', '')
			return item
		})

		formAux.paginas.map( (item,i) => {
			item.id = i
			item.createdBy = item.lastModifiedBy = sessionStorage.uid
			//item.createdDate = new Date().toISOString()
			return item
		})
		formAux.textosComplementarios.map( (item,i) => {
			item.createdBy = item.lastModifiedBy = sessionStorage.uid
			//item.createdDate = new Date().toISOString()
			item.id = i
			return item
		})

		return new ClientHttpRequest({
			service: formAux.id == 0 ? 'api/newContract' : 'api/updateContract',
			method: "POST",
			data: {...formAux},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})

	}
}

export const searchContract = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: Object.keys(form).length == 0 ? 'api/searchContract' : 'api/searchParamContract',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_SEARCH_CONTRACT, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getContract = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getContract',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))

			let aux = Object.assign({}, response.data)

			aux.idTipoContrato=response.data.tipoContrato.id
			aux.paginaActual=aux.textoActual=1
			aux.editorState=aux.textEditor=response.data.paginas[0].texto
			aux.textoComplementario=response.data.textosComplementarios[0].texto

			dispatch({ type: ACTION_GET_ITEM_CONTRACT, Obj: aux })
			return aux
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const typeContract = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/typeContract',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_TYPE_CONTRACT, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}



// WEBPACK FOOTER //
// ./src/modules/Configurations/Contracts/index.js